import React, { useState, useEffect } from 'react';
import { Modal, Box, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import { Close } from '@mui/icons-material';
import Loading from 'components/Loading';
import styled from 'styled-components';

const GRADE_LEVEL_OPTIONS = [
    'NoviceLow',
    'NoviceMid',
    'NoviceHigh',
    'IntermediateLow',
    'IntermediateMid',
    'IntermediateHigh',
    'AdvanceLow',
    'AdvanceMid',
    'AdvanceHigh',
];

const getValidGradeLevel = (value, fallback = 'NoviceLow') =>
    GRADE_LEVEL_OPTIONS.includes(value) ? value : fallback;

const ModalContent = styled(Box)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 24px;
    border-radius: 8px;
    width: 400px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
`;

const HeaderSection = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

const FooterSection = styled(Box)`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
`;

const AiGradingLevelModal = ({
    open,
    onClose,
    onSubmit,
    defaultGradeLevel = 'Advance',
    loading = false
}) => {
    const [selectedGradeLevel, setSelectedGradeLevel] = useState(() =>
        getValidGradeLevel(defaultGradeLevel, 'NoviceLow')
    );

    useEffect(() => {
        if (open) {
            setSelectedGradeLevel(getValidGradeLevel(defaultGradeLevel, 'NoviceLow'));
        }
    }, [open, defaultGradeLevel]);

    const handleSubmit = () => {
        onSubmit(getValidGradeLevel(selectedGradeLevel, 'NoviceLow'));
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="ai-grade-modal-title"
            aria-describedby="ai-grade-modal-description"
        >
            <ModalContent>
                <HeaderSection>
                    <h2 id="ai-grade-modal-title" style={{ margin: 0 }}>AI Grading Configuration</h2>
                    <Button onClick={onClose} sx={{ minWidth: 'auto', p: 1 }}>
                        <Close />
                    </Button>
                </HeaderSection>
                <FormControl variant="outlined" fullWidth sx={{ mb: 3 }}>
                    <InputLabel id="grade_level_select" style={{ background: 'white' }}>
                        Level for AI grading
                    </InputLabel>
                    <Select
                        labelId="grade_level_select"
                        id="grade_level_select"
                        value={getValidGradeLevel(selectedGradeLevel, 'NoviceLow')}
                        onChange={(e) => setSelectedGradeLevel(e.target.value)}
                        label="Level for AI grading"
                    >
                        <MenuItem value={'NoviceLow'}>Novice low</MenuItem>
                        <MenuItem value={'NoviceMid'}>Novice mid</MenuItem>
                        <MenuItem value={'NoviceHigh'}>Novice high</MenuItem>

                        <MenuItem value={'IntermediateLow'}>Intermediate low</MenuItem>
                        <MenuItem value={'IntermediateMid'}>Intermediate mid</MenuItem>
                        <MenuItem value={'IntermediateHigh'}>Intermediate high</MenuItem>

                        <MenuItem value={'AdvanceLow'}>Advance low</MenuItem>
                        <MenuItem value={'AdvanceMid'}>Advance mid</MenuItem>
                        <MenuItem value={'AdvanceHigh'}>Advance high</MenuItem>
                    </Select>
                </FormControl>
                <FooterSection>
                    <Button onClick={onClose} variant="outlined" disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        startIcon={loading ? <Loading white size={12} /> : null}
                    >
                        Submit
                    </Button>
                </FooterSection>
            </ModalContent>
        </Modal>
    );
};

export default AiGradingLevelModal;
